export default __webpack_public_path__ + "static/media/person.b7531c49.png";